import type { Writable } from 'svelte/store';

import type { ComponentType } from 'svelte';

export enum ToastType {
    Success = 'success',
    Error = 'error',
}

export interface Toast {
    type: ToastType;
    message: string | ComponentType;
    params: ToastParam;
}

export interface ToastsStoreState {
    toasts: Map<symbol, Toast>;
}

export interface ToastParam {
    persistence?: boolean;
}

export interface ToastsStore extends Writable<ToastsStoreState> {
    success: (message?: string | ComponentType, param?: ToastParam) => void;
    error: (message?: string | ComponentType, param?: ToastParam) => void;
    clear: () => void;
    removeByIndex: (key: symbol) => void;
    create: (type: ToastType, message: string | ComponentType, params: ToastParam) => void;
}
